module.exports={ethereum:{options:{autoRefreshOnNetworkChange:!1}}};